export class FlowChart {
  constructor(readonly sequence: Page[], readonly pageDefinitionMap: Map<string, Page>) {}
}

export interface Page {
  number: number;
  label: string;
  key: string;
  required: boolean;
  level: number;
  question: string;
  description: string[];
  multiple: boolean;
  options: Array<Option>;
  UUID: string;
}

export interface Option {
  id: string;
  label: string;
  description: string[];
  actions: Array<{ [key: string]: boolean }>;
  next: Page[];
  UUID: string;
}

export const MarkerPage = {
  EXIT: {
    label: 'Evaluation results',
    number: Infinity,
    required: false,
    key: '',
    level: 0,
    description: [''],
    multiple: false,
    question: '',
    options: [],
    UUID: 'f487125e-f878-4854-ad52-d75da2f2db8f'
  } as Page
};
